import { Component, Input, OnChanges } from "@angular/core"
import { LMModalService } from "../../services/lm-modal.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"

@Component({
    selector: "app-favorite-button",
    templateUrl: "./favorite-button.component.html",
    styleUrls: ["./favorite-button.component.scss"],
    standalone: false,
})
export class FavoriteButtonComponent extends EduComponent implements OnChanges {
    favoriteId: number = null
    isLoading: boolean = true

    @Input() learningObjectId: string
    @Input() hideLabelOnMobile: boolean
    @Input() hideLabelOnSmallDevices: boolean
    @Input() hideLabelOnTablet: boolean
    @Input() isLarge: boolean = false
    @Input() loggedinTooltip: string = null
    @Input() loggedoutTooltip: string = null
    @Input() gtmLabel?: string = ""
    @Input() disable: boolean = false
    @Input() classList: string

    public constructor(
        public userService: UserService,
        private lmModalService: LMModalService
    ) {
        super()
    }

    public ngOnChanges() {
        this.clearSubs()
        this.addSub(
            this.userService.favoritesReady.subscribe((favorites) => {
                const favorite = (favorites || []).find(
                    (favoriteObj) => favoriteObj.loId === this.learningObjectId
                )
                this.favoriteId = favorite ? favorite.favoriteId : null
                this.isLoading = false
            })
        )
    }

    public onFavoriteClick() {
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal()
            return
        }
        if (this.isLoading) {
            return
        }
        if (this.favoriteId) {
            this.userService.deleteFavorite(this.favoriteId)
        } else {
            this.userService.addFavorite(this.learningObjectId)
        }
        this.isLoading = true
    }
}
